// extracted by mini-css-extract-plugin
export default {"suggestion":"Suggestion_suggestion__ERoqs","search_item":"Suggestion_search_item__YSx09","search_item_button":"Suggestion_search_item_button__U9wHT"};